import { Menu } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ACTIVE_FORM_KEY } from "../../config";

export default function FormMenu({ form = {}, activeFormKey }) {
  const { t } = useTranslation();
  const push = useNavigate();
  const values = useMemo(() =>
    Object.keys(form)
      .sort((a, b) => form[a].position - form[b].position)
      .map((key) => ({
        value: key,
        label: form[key].label,
      }))
    , [form]);

  return (

    <Menu
      mode="inline"
      defaultSelectedKeys={[activeFormKey]}
      selectedKeys={[activeFormKey]}
      style={{ overflowY: 'auto', overflowX: 'hidden' }}
      onSelect={group => {
        push(`${window.location.pathname}?${ACTIVE_FORM_KEY}=${group.key}`);
      }}
    >
      {values.map((v, i) => (
        <Menu.Item key={v.value}>
          {t(v.label)}
        </Menu.Item>
      ))}

    </Menu>

  );
}
